import { BarChart3, BrainCircuit, Zap } from "lucide-react";
import type { ComponentType } from "react";

import { AutoSparklesIcon } from "./AutoSparklesIcon";

export type ComposerModeId = "auto" | "automation" | "digital-worker" | "insight";

export type ComposerMode = {
  id: ComposerModeId;
  buttonLabel: string;
  title: string;
  description: string;
  Icon: ComponentType<{ className?: string }>;
};

export const COMPOSER_MODES: ComposerMode[] = [
  {
    id: "auto",
    buttonLabel: "Auto",
    title: "Auto-detect",
    description: "Infer the type from what you write",
    Icon: AutoSparklesIcon,
  },
  {
    id: "automation",
    buttonLabel: "Automation",
    title: "Automation",
    description: "Connects systems, syncs data, triggers actions",
    Icon: Zap,
  },
  {
    id: "digital-worker",
    buttonLabel: "Worker",
    title: "Digital Worker",
    description: "Broader recurring tasks for a person or team",
    Icon: BrainCircuit,
  },
  {
    id: "insight",
    buttonLabel: "Insight",
    title: "Insight",
    description: "Analytical questions, charts & summaries",
    Icon: BarChart3,
  },
];

export const DEFAULT_COMPOSER_MODE = COMPOSER_MODES[0];

export function getComposerMode(id: ComposerModeId): ComposerMode {
  return COMPOSER_MODES.find((mode) => mode.id === id) ?? DEFAULT_COMPOSER_MODE;
}
